import { MODAL_CHANGE_EMAIL_OTP } from '@components/App/Modal/constants'
import type { ChangeEmailResponse } from '@store/reducers/account/types'
import { openModal } from '@storeOld/reducers/ui'
import { call, put } from 'redux-saga/effects'

import API from '@/api'
import { type AccountActions, InternalAccountActions } from '../actions'

export function* changeEmail({
  payload: { email },
}: ReturnType<typeof AccountActions.changeEmail>) {
  const response: ChangeEmailResponse = yield call(API.UpdateEmail.request, {
    newEmail: email,
  })
  yield put(
    InternalAccountActions.setOtp({
      email,
      error: null,
      expiredAt: response.emailVerificationCodeExpiresAt,
    })
  )

  yield put(openModal(MODAL_CHANGE_EMAIL_OTP))
}
